import { render, staticRenderFns } from "./GeneratePdf.vue?vue&type=template&id=b36010be&"
import script from "./GeneratePdf.vue?vue&type=script&lang=js&"
export * from "./GeneratePdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports